export default "__VITE_ASSET__Cq$Pnxnn__"